// extracted by mini-css-extract-plugin
export default {"about":"AboutSection_about__JQWz2","head":"AboutSection_head__bvW5n","title":"AboutSection_title__aazsg"};